/* eslint-disable max-len */
import * as React from 'react';
import { Component } from 'react';
import SocialNetworkIcon, { SocialNetworkIconProps } from '../SocialNetworkIcon';

class TikTokIcon extends Component<SocialNetworkIconProps> {
  public render() {
    return (
      <SocialNetworkIcon {...this.props}>
        <path
          transform='translate(29, 23) scale(1.1)'
          d='M41.4 6.39999C41.1 6.19999 40.8 6.19999 40.5 6.29999C38 7.39999 35.4 6.59999 33.9 4.59999C33.2 3.69999 32.8 2.49999 32.8 1.39999C32.8 1.09999 32.7 0.899994 32.5 0.699994C32.3 0.499994 32.1 0.399994 31.8 0.399994H21.6C21 0.399994 20.6 0.799994 20.6 1.39999V36.9C20.6 37 20.6 37 20.6 37.1C20.4 38.9 19 40.2 17.2 40.2C15.3 40.2 13.7 38.6 13.7 36.7C13.7 34.9 15 33.5 16.8 33.3C17.3 33.2 17.7 32.8 17.7 32.3V20.7C17.7 20.1 17.3 19.7 16.7 19.7C16.7 19.7 16.6 19.7 16.5 19.7C7.3 20.1 0.199997 27.5 0.199997 36.7C0.199997 46.1 7.8 53.7 17.2 53.7C26 53.7 33.4 46.9 34.1 38.2C34.2 38.1 34.2 37.9 34.2 37.8V18.5C36.4 19 38.7 19.2 41.1 18.8C41.6 18.7 41.9 18.3 41.9 17.8V7.19999C41.9 6.89999 41.7 6.59999 41.4 6.39999ZM39.9 17C37.6 17.2 35.5 17 33.4 16.3C33.1 16.2 32.8 16.3 32.5 16.4C32.2 16.6 32.1 16.9 32.1 17.2V37.4C32.1 37.5 32.1 37.6 32 37.7C31.5 45.5 24.9 51.7 17.1 51.7C8.8 51.7 2.1 45 2.1 36.7C2.1 28.9 7.9 22.5 15.6 21.8V31.5C13.3 32.2 11.6 34.3 11.6 36.7C11.6 39.7 14.1 42.2 17.1 42.2C19.8 42.2 22.1 40.2 22.5 37.6C22.6 37.5 22.6 37.3 22.6 37.2V2.39999H30.9C31.1 3.69999 31.6 4.79999 32.3 5.79999C34 8.09999 37 9.29999 39.9 8.59999V17Z'
          fill={this.props.color}
        />
      </SocialNetworkIcon>
    );
  }
}

export default TikTokIcon;
